"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrlParam = void 0;
var getGlobalWindow_1 = require("./getGlobalWindow");
function getUrlParam(str) {
    var _a;
    var _b, _c, _d;
    if (str === void 0) { str = ""; }
    var realUrlParam = {};
    var url = str || ((_b = (0, getGlobalWindow_1.getWindow)().location) === null || _b === void 0 ? void 0 : _b.search) || "";
    if (!url) {
        return realUrlParam;
    }
    var paramStr = ((_c = url.split("?")) === null || _c === void 0 ? void 0 : _c[2]) || ((_d = url.split("?")) === null || _d === void 0 ? void 0 : _d[1]) || "";
    var paramArr = paramStr.split("&");
    var urlParam = {};
    for (var i = 0; i < paramArr.length; i += 1) {
        _a = paramArr[i].split("="), urlParam[paramArr[i].split("=")[0]] = _a[1];
    }
    Object.keys(urlParam).forEach(function (k) {
        if (!k) {
            return;
        }
        var v = urlParam[k];
        if (v) {
            if (v === "undefined" || v === "null") {
                realUrlParam[k] = "";
            }
            else {
                realUrlParam[k] = v;
            }
        }
    });
    return realUrlParam;
}
exports.getUrlParam = getUrlParam;
